<template>
	<div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
			
			<el-form-item label="归属:" prop="name">
				<el-select size="mini" v-model="ruleForm.pid" placeholder="归属" style="width: 200px;">
					<el-option v-for="item in agentList" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			
			<el-form-item label="App名称:" prop="name">
				<el-input size="small" v-model="ruleForm.name"></el-input>
			</el-form-item>
				
			<el-form-item label="App账号:" prop="account">
				<el-input size="small" v-model="ruleForm.account"></el-input>
			</el-form-item>
			
			<el-form-item label="排序编号:" prop="sorts">
				<el-input size="small" v-model="ruleForm.sorts"></el-input>
			</el-form-item>
			
			<el-form-item>
				<el-button type="primary" @click="submitForm('ruleForm')">立即添加</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		props:{
			agentList:{
				type:Array
			}
		},
	    data() {
			return {
				ruleForm: {
					pid:0,
					name:'',
					account:'',
					sorts:0
				},
				rules: {
					name: [{required: true, message: '请输入app名称', trigger: 'blur'}],
					account: [{required: true, message: '请输入账号', trigger: 'blur'}],
					sorts:[{required: true, message: '请输入排序', trigger: 'blur'}]
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
	    methods: {
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '添加中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Set/addService", this.ruleForm).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '添加成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return _this.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 90px;
	    height: 90px;
	    line-height: 90px;
	    text-align: center;
	  }
	  .avatar {
	    min-width: 90px;
	    height: 90px;
	    display: block;
	  }
</style>